import { Autocomplete, TextField } from '@mui/material'
import React, { useState } from 'react'
import { Container } from './styles'
import { CadastroState } from '../../index'
import { states, statesParse } from '../../../../utils/states'
import { companyType } from '../../../../utils/companytype'
import { cnpjCpfMask, zipcodeMaks } from '../../../../utils/masks'
import classNames from 'classnames'

interface Props {
    type: CadastroState
    setType: (valor: string) => void
    cnpj_cpf: CadastroState
    setCnpj_cpf: (valor: string) => void
    zipcode: CadastroState
    setZipcode: (valor: string) => void
    address: CadastroState
    setAddress: (valor: string) => void
    number: CadastroState
    setNumber: (valor: string) => void
    complement: CadastroState
    setComplement: (valor: string) => void
    district: CadastroState
    setDistrict: (valor: string) => void
    city: CadastroState
    setCity: (valor: string) => void
    state: CadastroState
    setState: (valor: string) => void
}
export default function CompanyDataStep({
    type,
    setType,
    cnpj_cpf,
    setCnpj_cpf,
    zipcode,
    setZipcode,
    address,
    setAddress,
    number,
    setNumber,
    complement,
    setComplement,
    district,
    setDistrict,
    city,
    setCity,
    state,
    setState,
}: Props) {
    const [focus, setFocus] = useState(false)
    function handleChance(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.name === 'cnpj/cpf') {
            e.currentTarget.maxLength = 18
            let value = cnpjCpfMask(e.currentTarget.value)

            setCnpj_cpf(value)
        }

        if (e.target.name === 'zipcode') {
            e.currentTarget.maxLength = 9
            let value = zipcodeMaks(e.currentTarget.value)

            setZipcode(value)
        }
    }

    const sigla: keyof typeof statesParse = state as keyof typeof statesParse
    const estado = statesParse[sigla]

    return (
        <Container className={classNames({ 'focus ': focus })}>
            <div>
                {/* <TextField 
              name='cnpj/cpf'
              onChange={handleChance}
              value={cnpj_cpf}
              sx={{ width: '100%'}}
              type="text" 
              label="CNPJ/CPF"
            /> */}
                <label
                    htmlFor="cnpj/cpf"
                    className="text-gray-700 text-sm label block"
                >
                    CPF/CNPJ
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="cnpj/cpf"
                    name="cnpj/cpf"
                    onChange={handleChance}
                    value={cnpj_cpf}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="CPF/CNPJ"
                />
            </div>

            <div>
                <Autocomplete
                    onChange={(event, newValue) =>
                        setType(newValue?.label || 'Selecione')
                    }
                    disablePortal
                    value={{ label: `${type}` }}
                    isOptionEqualToValue={(option, value) => {
                        return option.label === value.label
                    }}
                    id="companyType"
                    options={companyType}
                    renderInput={(params) => (
                        // <TextField {...params} label="Tipo da empresa" />
                        <div ref={params.InputProps.ref}>
                            <label
                                {...params.InputLabelProps}
                                className="text-gray-700 text-sm label block"
                            >
                                Tipo da empresa
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input
                                {...params.inputProps}
                                className={classNames(
                                    'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                                )}
                                placeholder="Tipo da empresa"
                            />
                        </div>
                    )}
                />
            </div>

            <div>
                {/* <TextField
                    name="zipcode"
                    onChange={handleChance}
                    value={zipcode}
                    sx={{ width: '100%' }}
                    type="text"
                    label="Zipcode"
                /> */}
                <label
                    htmlFor="zipcode"
                    className="text-gray-700 text-sm label block"
                >
                    CEP
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="zipcode"
                    name="zipcode"
                    onChange={handleChance}
                    value={zipcode}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="CEP"
                />
            </div>

            <div>
                {/* <TextField
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                    sx={{ width: '100%' }}
                    type="text"
                    label="Endereço"
                /> */}
                <label
                    htmlFor="address"
                    className="text-gray-700 text-sm label block"
                >
                    Endereço
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="address"
                    name="address"
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Endereço"
                />
            </div>

            <div>
                {/* <TextField
                    onChange={(e) => setNumber(e.target.value)}
                    value={number}
                    sx={{ width: '100%' }}
                    type="text"
                    label="Número"
                /> */}

                <label
                    htmlFor="number"
                    className="text-gray-700 text-sm label block"
                >
                    Número
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="number"
                    name="number"
                    onChange={(e) => setNumber(e.target.value)}
                    value={number}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Número"
                />
            </div>

            <div>
                {/* <TextField
                    onChange={(e) => setComplement(e.target.value)}
                    value={complement}
                    sx={{ width: '100%' }}
                    type="text"
                    label="Complemento"
                /> */}
                <label
                    htmlFor="complement"
                    className="text-gray-700 text-sm label block"
                >
                    Complemento
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="complement"
                    name="complement"
                    onChange={(e) => setComplement(e.target.value)}
                    value={complement}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Complemento"
                />
            </div>

            <div>
                {/* <TextField
                    onChange={(e) => setDistrict(e.target.value)}
                    value={district}
                    sx={{ width: '100%' }}
                    type="text"
                    label="Distrito"
                /> */}
                <label
                    htmlFor="district"
                    className="text-gray-700 text-sm label block"
                >
                    Distrito
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="district"
                    name="district"
                    onChange={(e) => setDistrict(e.target.value)}
                    value={district}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Distrito"
                />
            </div>

            <div>
                {/* <TextField
                    onChange={(e) => setCity(e.target.value)}
                    value={city}
                    sx={{ width: '100%' }}
                    type="text"
                    label="Cidade"
                /> */}
                <label
                    htmlFor="city"
                    className="text-gray-700 text-sm label block"
                >
                    Cidade
                    <span className="text-red-500 required-dot">*</span>
                </label>
                <input
                    type="text"
                    id="city"
                    name="city"
                    onChange={(e) => setCity(e.target.value)}
                    value={city}
                    className={classNames(
                        'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                    )}
                    placeholder="Cidade"
                />
            </div>

            <div>
                <Autocomplete
                    onChange={(event, newValue) => {
                        setState(newValue?.sigla || 'Selecione')
                        setFocus(false)
                    }}
                    isOptionEqualToValue={(option, value) => {
                        return option.sigla === value.sigla
                    }}
                    value={{ label: `${estado}`, sigla: `${state}` }}
                    disablePortal
                    id="city"
                    options={states}
                    renderInput={(params) => (
                        // <TextField {...params} label="Estado" />
                        <div
                            ref={params.InputProps.ref}
                            onFocus={() => setFocus(true)}
                            onBlur={() => setFocus(false)}
                        >
                            <label
                                {...params.InputLabelProps}
                                className="text-gray-700 text-sm label block"
                            >
                                Estado
                                <span className="text-red-500 required-dot">
                                    *
                                </span>
                            </label>
                            <input
                                {...params.inputProps}
                                className={classNames(
                                    'rounded-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent mt-1'
                                )}
                                placeholder="Estado"
                            />
                        </div>
                    )}
                />
            </div>
        </Container>
    )
}
